
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexv6aPQuT7lSMeta } from "/codebuild/output/src361767129/src/pages/index.vue?macro=true";
import { default as aboutVStekWXb4FMeta } from "/codebuild/output/src361767129/src/pages/about.vue?macro=true";
import { default as dataMVtTrDTY2xMeta } from "/codebuild/output/src361767129/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionQfwtQW0LWfMeta } from "/codebuild/output/src361767129/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningMkSy8GWvXdMeta } from "/codebuild/output/src361767129/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyZWCqOqtIg6Meta } from "/codebuild/output/src361767129/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accounto7RI7d3lAuMeta } from "/codebuild/output/src361767129/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statuekgeGQGio9uMeta } from "/codebuild/output/src361767129/src/pages/account-settings/statue.vue?macro=true";
import { default as supportI7oNvQOkHDMeta } from "/codebuild/output/src361767129/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settings9NfYvOpcrPMeta } from "/codebuild/output/src361767129/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountRZvTkCajvDMeta } from "/codebuild/output/src361767129/src/pages/activate-account.vue?macro=true";
import { default as companyi1BqqTgKthMeta } from "/codebuild/output/src361767129/src/pages/admin/company.vue?macro=true";
import { default as consents3K2TH6CkqzMeta } from "/codebuild/output/src361767129/src/pages/admin/consents.vue?macro=true";
import { default as leadsIBKtvrV8IDMeta } from "/codebuild/output/src361767129/src/pages/admin/leads.vue?macro=true";
import { default as paymentskW1IVpO9YrMeta } from "/codebuild/output/src361767129/src/pages/admin/payments.vue?macro=true";
import { default as premiumiYE0VUjoccMeta } from "/codebuild/output/src361767129/src/pages/admin/premium.vue?macro=true";
import { default as profilesx7v08qAtppMeta } from "/codebuild/output/src361767129/src/pages/admin/profiles.vue?macro=true";
import { default as userslR9W9xKqAWMeta } from "/codebuild/output/src361767129/src/pages/admin/users.vue?macro=true";
import { default as change_45password61GhiU5KKbMeta } from "/codebuild/output/src361767129/src/pages/change-password.vue?macro=true";
import { default as _91id_93vtWKjB8oOYMeta } from "/codebuild/output/src361767129/src/pages/chat/[id].vue?macro=true";
import { default as aib6u1NY1LY8Meta } from "/codebuild/output/src361767129/src/pages/chat/ai.vue?macro=true";
import { default as indexC0i33LYmKJMeta } from "/codebuild/output/src361767129/src/pages/chat/index.vue?macro=true";
import { default as chat3osrE2GmyUMeta } from "/codebuild/output/src361767129/src/pages/chat.vue?macro=true";
import { default as _91id_93lPrEcLx2AxMeta } from "/codebuild/output/src361767129/src/pages/client/profile/[id].vue?macro=true";
import { default as indexrQDO3YBrqgMeta } from "/codebuild/output/src361767129/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93FUVpf2kSAuMeta } from "/codebuild/output/src361767129/src/pages/contacts/[id].vue?macro=true";
import { default as indexZrPtxESKoFMeta } from "/codebuild/output/src361767129/src/pages/contacts/index.vue?macro=true";
import { default as contacts66sWPzB3KnMeta } from "/codebuild/output/src361767129/src/pages/contacts.vue?macro=true";
import { default as _91userId_936wX58DRJr5Meta } from "/codebuild/output/src361767129/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as index6ClLQOP1p8Meta } from "/codebuild/output/src361767129/src/pages/login/index.vue?macro=true";
import { default as register_45success4cXbaEF0h3Meta } from "/codebuild/output/src361767129/src/pages/login/register-success.vue?macro=true";
import { default as loginkGv07vbOkrMeta } from "/codebuild/output/src361767129/src/pages/login.vue?macro=true";
import { default as logoutWcQvCXY2HuMeta } from "/codebuild/output/src361767129/src/pages/logout.vue?macro=true";
import { default as consentssAtSqqGkkHMeta } from "/codebuild/output/src361767129/src/pages/manager/consents.vue?macro=true";
import { default as integrationsAvTHmUYjbtMeta } from "/codebuild/output/src361767129/src/pages/manager/integrations.vue?macro=true";
import { default as leadsDdbQwsV1iLMeta } from "/codebuild/output/src361767129/src/pages/manager/leads.vue?macro=true";
import { default as paymentsltV4qo2KWZMeta } from "/codebuild/output/src361767129/src/pages/manager/payments.vue?macro=true";
import { default as profilep2IYQBy8kLMeta } from "/codebuild/output/src361767129/src/pages/manager/profile.vue?macro=true";
import { default as teamWrofsHxPcJMeta } from "/codebuild/output/src361767129/src/pages/manager/team.vue?macro=true";
import { default as index3HJLED9trYMeta } from "/codebuild/output/src361767129/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientlbMTkHqTaFMeta } from "/codebuild/output/src361767129/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src361767129/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplacerwnWHDrg0UMeta } from "/codebuild/output/src361767129/src/pages/marketplace.vue?macro=true";
import { default as subscribeTzSm0yAgSIMeta } from "/codebuild/output/src361767129/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clienteOBxmeMiARMeta } from "/codebuild/output/src361767129/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientkZ12mDiD8ZMeta } from "/codebuild/output/src361767129/src/pages/orders/my.client.vue?macro=true";
import { default as privacybkKAG0uWZPMeta } from "/codebuild/output/src361767129/src/pages/privacy.vue?macro=true";
import { default as index6utU0TrtQzMeta } from "/codebuild/output/src361767129/src/pages/recover/index.vue?macro=true";
import { default as successd7nYUkqQicMeta } from "/codebuild/output/src361767129/src/pages/register/success.vue?macro=true";
import { default as _91id_93v9a2iDVq3rMeta } from "/codebuild/output/src361767129/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexGU5bnu6LcSMeta } from "/codebuild/output/src361767129/src/pages/sales/profile/index.vue?macro=true";
import { default as statue23zmxEYmw1Meta } from "/codebuild/output/src361767129/src/pages/statue.vue?macro=true";
import { default as success5drDWxXHf7Meta } from "/codebuild/output/src361767129/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubTQG9O0ESxDMeta } from "/codebuild/output/src361767129/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubTQG9O0ESxD } from "/codebuild/output/src361767129/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexv6aPQuT7lSMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutVStekWXb4FMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutVStekWXb4FMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settings9NfYvOpcrPMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settings9NfYvOpcrPMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src361767129/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountRZvTkCajvDMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountRZvTkCajvDMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyi1BqqTgKthMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyi1BqqTgKthMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consents3K2TH6CkqzMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consents3K2TH6CkqzMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsIBKtvrV8IDMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsIBKtvrV8IDMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentskW1IVpO9YrMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentskW1IVpO9YrMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumiYE0VUjoccMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumiYE0VUjoccMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesx7v08qAtppMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesx7v08qAtppMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: userslR9W9xKqAWMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: userslR9W9xKqAWMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45password61GhiU5KKbMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45password61GhiU5KKbMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/change-password.vue")
  },
  {
    name: chat3osrE2GmyUMeta?.name,
    path: "/en/chat",
    meta: chat3osrE2GmyUMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93vtWKjB8oOYMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aib6u1NY1LY8Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: indexC0i33LYmKJMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chat3osrE2GmyUMeta?.name,
    path: "/pl/chat",
    meta: chat3osrE2GmyUMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93vtWKjB8oOYMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aib6u1NY1LY8Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: indexC0i33LYmKJMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93lPrEcLx2AxMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93lPrEcLx2AxMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexrQDO3YBrqgMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexrQDO3YBrqgMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/client/profile/index.vue")
  },
  {
    name: contacts66sWPzB3KnMeta?.name,
    path: "/en/contacts",
    meta: contacts66sWPzB3KnMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93FUVpf2kSAuMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexZrPtxESKoFMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contacts66sWPzB3KnMeta?.name,
    path: "/pl/contacts",
    meta: contacts66sWPzB3KnMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93FUVpf2kSAuMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexZrPtxESKoFMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_936wX58DRJr5Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_936wX58DRJr5Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexv6aPQuT7lSMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexv6aPQuT7lSMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/index.vue")
  },
  {
    name: loginkGv07vbOkrMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src361767129/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: index6ClLQOP1p8Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45success4cXbaEF0h3Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginkGv07vbOkrMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src361767129/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: index6ClLQOP1p8Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45success4cXbaEF0h3Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutWcQvCXY2HuMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutWcQvCXY2HuMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentssAtSqqGkkHMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentssAtSqqGkkHMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsAvTHmUYjbtMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsAvTHmUYjbtMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsDdbQwsV1iLMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsDdbQwsV1iLMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsltV4qo2KWZMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsltV4qo2KWZMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profilep2IYQBy8kLMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profilep2IYQBy8kLMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamWrofsHxPcJMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamWrofsHxPcJMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/manager/team.vue")
  },
  {
    name: marketplacerwnWHDrg0UMeta?.name,
    path: "/en/marketplace",
    meta: marketplacerwnWHDrg0UMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src361767129/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientlbMTkHqTaFMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src361767129/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplacerwnWHDrg0UMeta?.name,
    path: "/pl/marketplace",
    meta: marketplacerwnWHDrg0UMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src361767129/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientlbMTkHqTaFMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src361767129/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeTzSm0yAgSIMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeTzSm0yAgSIMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clienteOBxmeMiARMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src361767129/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clienteOBxmeMiARMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src361767129/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientkZ12mDiD8ZMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src361767129/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientkZ12mDiD8ZMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src361767129/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacybkKAG0uWZPMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacybkKAG0uWZPMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: index6utU0TrtQzMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: index6utU0TrtQzMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src361767129/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src361767129/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93v9a2iDVq3rMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93v9a2iDVq3rMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexGU5bnu6LcSMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexGU5bnu6LcSMeta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statue23zmxEYmw1Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statue23zmxEYmw1Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: success5drDWxXHf7Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: success5drDWxXHf7Meta || {},
    component: () => import("/codebuild/output/src361767129/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubTQG9O0ESxDMeta?.name,
    path: "/old-page",
    component: component_45stubTQG9O0ESxD
  }
]